import {
  DATASTRATEGY,
  IEntity,
  STORAGESTRATEGY,
} from '@proximus/entity-manager';
import { SessionStorageStrategy } from '@proximus/entity-manager/lib/storage/strategies/session-storage.strategy';

export const PublicWifiProductsEntity: IEntity<any> = {
  url: '/rest/smart-wifi/products',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'sw:products',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const PublicWifiAccountsEntity: IEntity<any> = {
  url: '/rest/smart-wifi/accounts/serviceId/{serviceId}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
    'customHeaders',
  ],
  rel: 'sw:getSmartWifiAccounts',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
  customHeaders: {
    Accept: 'application/json',
  },
};

export const PublicWifiCreateAliasEntity: IEntity<any> = {
  url: '/rest/smart-wifi/account/createAlias',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
    'customHeaders',
  ],
  rel: 'sw:createSmartWifiAlias',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
  customHeaders: {
    Accept: 'application/json',
  },
};

export const PublicWifiRenameAliasEntity: IEntity<any> = {
  url: '/rest/smart-wifi/account/renameAlias',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
    'customHeaders',
  ],
  rel: 'sw:renameSmartWifiAlias',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
  customHeaders: {
    Accept: 'application/json',
  },
};

export const PublicWifiUpdatePasswordEntity: IEntity<any> = {
  url: '/rest/smart-wifi/account/updatePassword',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
    'customHeaders',
  ],
  rel: 'sw:updateSmartWifiPassword',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
  customHeaders: {
    Accept: 'application/json',
  },
};
